"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../state");
var _hooks = require("../../../../hooks");
var _Component = require("./Component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Container = function Container(_ref) {
  var walletsPath = _ref.walletsPath,
    withdrawPath = _ref.withdrawPath,
    replenishPath = _ref.replenishPath,
    className = _ref.className;
  var _useBalancesWithTotal = (0, _state.useBalancesWithTotal)(),
    balances = _useBalancesWithTotal.balances,
    balancesLoading = _useBalancesWithTotal.balancesLoading,
    totalBalanceState = _useBalancesWithTotal.totalBalanceState;
  var _usePortfolioBalance = (0, _hooks.usePortfolioBalance)({
      balances: balances,
      balancesLoading: balancesLoading
    }),
    loading = _usePortfolioBalance.loading,
    minPercentBalances = _usePortfolioBalance.minPercentBalances,
    otherBalanceTotal = _usePortfolioBalance.otherBalanceTotal;
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    walletsPath: walletsPath,
    withdrawPath: withdrawPath,
    replenishPath: replenishPath,
    className: className,
    loading: loading,
    minPercentBalances: minPercentBalances,
    totalBalance: totalBalanceState.data,
    otherBalanceTotal: otherBalanceTotal
  });
};
exports.Container = Container;